import { Button, Drawer, Form, InputNumber, Select, Input, message } from "antd";
import React, { useState } from "react";
import { db } from "../../firebase/config";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

export default function CreateSRoll({ materialData, materialLoading }) {
   const [open, setOpen] = useState(false);
   const [selectedMaterial, setSelectedMaterial] = useState();
   const [form] = Form.useForm();
   //    const [widths, setWidths] = useState([]);

   const showDrawer = () => {
      setOpen(true);
   };
   const onClose = () => {
      setOpen(false);
   };

   //when a form finishes
   const onFinish = (values) => {
      const data = {
         ...values,
         comment: values.comment || "", // Set the comment field to an empty string if it's not set explicitly in the form
      };
      const newData = {
         ...data,
         material: selectedMaterial,
         created: serverTimestamp(),
         updated: serverTimestamp(),
      };
      addNewRoll(newData);
   };
   //if form failed
   const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
   };

   //what happens if you search
   const onSearch = (value) => {
      console.log("search:", value);
   };

   const handleMaterialChange = (value, object) => {
      setSelectedMaterial(object);
   };

   //    const handleWidths = (value) => {
   //       var arrayOfNumbers = value.map(Number);
   //       setWidths(arrayOfNumbers);
   //    };

   //adds the roll
   const addNewRoll = async (data) => {
      const updateRef = collection(db, "secondWarehouseRolls");
      let newData = {
         ...data,
         created: serverTimestamp(),
         updated: serverTimestamp(),
      };
      try {
         await addDoc(updateRef, newData); // Use await to ensure that the document is added before resetting the form fields
         message.success(`Success! Roll has been created.`);
         setOpen(false);
         form.resetFields(); // Reset form fields after the data is successfully added
      } catch (error) {
         message.error(error);
      }
   };
   return (
      <>
         <Button onClick={showDrawer}>Create Roll</Button>
         <Drawer title="Add roll" placement="right" onClose={onClose} open={open} width={500}>
            <Form form={form} name="basic" onFinish={onFinish} layout="vertical" onFinishFailed={onFinishFailed} autoComplete="off" style={{ width: "100%" }}>
               <Form.Item
                  label="Material"
                  name="selectedMaterialID"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <Select
                     showSearch
                     placeholder="Select a material"
                     optionFilterProp="children"
                     onSearch={onSearch}
                     onChange={handleMaterialChange}
                     fieldNames={{ label: "material", value: "id" }}
                     loading={materialLoading}
                     filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                     options={materialData && materialData}
                  />
               </Form.Item>

               <Form.Item
                  label="Meters"
                  name="remainingMeters"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <InputNumber style={{ width: "100%" }} placeholder="Enter the amount of meters inside Material roll" />
               </Form.Item>

               {/* <Form.Item
                  label="Material Widths"
                  name="materialWidths"
                  rules={[
                     {
                        required: true,
                        message: "Please input Material Widths",
                     },
                  ]}
               >
                  <div>
                     <Select
                        mode="tags"
                        style={{
                           width: "100%",
                        }}
                        tokenSeparators={[","]}
                        placeholder="Enter widths for the roll"
                        onChange={handleWidths}
                     />
                     <Text style={{ fontSize: "12px", color: "gray", fontStyle: "italic" }}>
                        Write , (comma) or press "enter" to separate widths. Note: You can only add numbers
                     </Text>
                  </div>
               </Form.Item> */}

               <Form.Item
                  label="Width"
                  name="rollWidth"
                  rules={[
                     {
                        required: true,
                        message: "Please input Meters",
                     },
                  ]}
               >
                  <InputNumber style={{ width: "100%" }} placeholder="Enter width of the roll" />
               </Form.Item>

               <Form.Item name="comment" label="Comment">
                  <Input.TextArea name="comment" rows={2} placeholder="Roll comment" />
               </Form.Item>

               <Form.Item>
                  <Button type="primary" htmlType="submit">
                     Add Roll
                  </Button>
               </Form.Item>
            </Form>
         </Drawer>
      </>
   );
}
